import { FC } from 'react';

import {
  PropertyCharacteristicListItem,
  SupportPropertyCharacteristics,
} from '@type-def_iqfu/PropertyCharacteristicsType';

import {
  PropertyCharacteristicCategoryKey,
  PropertyCharacteristicCategoryKeys,
  PropertyCharacteristicCategoryLabels,
} from '@constants_iqfu';

import styles from './SpecialFlagsView.module.scss';

type Props = {
  propertyTypes: PropertyCharacteristicListItem[] | null | undefined;
  characteristics: SupportPropertyCharacteristics | null | undefined;
  propertyTypeLabel?: string;
};

const renderItems = (items: PropertyCharacteristicListItem[] | null | undefined) => {
  if (!Array.isArray(items) || items.length === 0) {
    return <span className={styles.empty}>未選択</span>;
  }
  return items.map((item) => (
    <span key={item.id} className={styles.value_item}>
      {item.name}
    </span>
  ));
};

const SpecialFlagsView: FC<Props> = ({ propertyTypes, characteristics, propertyTypeLabel = '物件タイプ' }) => {
  return (
    <>
      <div className={styles.row}>
        <label className={styles.label}>{propertyTypeLabel}</label>
        <div className={styles.values}>{renderItems(propertyTypes)}</div>
      </div>
      {PropertyCharacteristicCategoryKeys.map((key: PropertyCharacteristicCategoryKey) => (
        <div key={key} className={styles.row}>
          <label className={styles.label}>{PropertyCharacteristicCategoryLabels[key]}</label>
          <div className={styles.values}>{renderItems(characteristics?.[key])}</div>
        </div>
      ))}
    </>
  );
};

export default SpecialFlagsView;
